<template>
    <nav-bar title="用户明细" />
    <Content :bottom="0">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getOrganizationalStructure" />
      <organizational-cus-menu :list="organizationalList"  />
    </Content>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { getCompanyUserList } from '@/api/cuser'

export default {
  name: 'CompanyUser', // 用户
  setup (props) {
    // 获取组织架构数据
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const organizationalList = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getCompanyUserList, (data) => {
      organizationalList.value = data
    }, { companyId: companyId.value })
    const getOrganizationalStructure = getDataLoading
    getOrganizationalStructure()
    return {
      showLoading,
      isLoading,
      organizationalList,
      getOrganizationalStructure
    }
  }
}
</script>

<style scoped>

</style>
